import { z } from 'zod';

export const ApplyRevisionPlanSelectionSchema = z.object({
  categoryId: z.uuid(),
  itemType: z.enum(['PRODUCT', 'SERVICE']),
  itemId: z.uuid(),
  quantity: z.number().int().positive().optional(),
  unitPriceCents: z.string().regex(/^\d+$/).optional(),
});

export const ApplyRevisionPlanBodySchema = z.object({
  revisionPlanId: z.uuid(),
  selections: z.array(ApplyRevisionPlanSelectionSchema),
  vehicleModelId: z.uuid().optional(),
  manufactureYear: z.number().int().min(1900).max(2100).optional(),
  vehicleEngineId: z.uuid().optional(),
  placeId: z.uuid().optional(),
  assignedMechanicUserId: z.uuid().optional(),
});

export const ApplyRevisionPlanResponseSchema = z.object({
  addedItemIds: z.array(z.uuid()),
});

export type ApplyRevisionPlanSelection = z.infer<typeof ApplyRevisionPlanSelectionSchema>;
export type ApplyRevisionPlanBody = z.infer<typeof ApplyRevisionPlanBodySchema>;
export type ApplyRevisionPlanResponse = z.infer<typeof ApplyRevisionPlanResponseSchema>;
